import React from 'react';
import {useTranslation} from 'react-i18next';

import {EFRadioGroup} from '_/utilities/form';

import {AutocompleteFilter} from '../AutocompleteBase/AutocompleteBase';

import {ActiveFilterColumn, ActiveFilterRow} from './ActiveFilter.styles';
import {ActiveState} from './ActiveFilter.types';
import {ActiveFilterTranslation, activeStateItems} from './ActiveFilter.utils';

export type ActiveStateFilterState = {activeState: ActiveState};

/** The active/inactive filter shared by the masterdata-like autocompletes. */
export function useActiveStateFilter(
  persistenceKey: string
): AutocompleteFilter<ActiveStateFilterState> {
  const {t} = useTranslation('common');
  return {
    defaultState: {activeState: 'ACTIVE'},
    dialogHeader: t('activeFilter.dialog.header'),
    toText: ({activeState}) => ActiveFilterTranslation[activeState],
    renderFields: (control) => (
      <ActiveFilterRow>
        <ActiveFilterColumn>
          <EFRadioGroup
            control={control}
            items={activeStateItems}
            label={t('activeFilter.dialog.activeStateFilter')}
            name='activeState'
          />
        </ActiveFilterColumn>
      </ActiveFilterRow>
    ),
    persistenceKey,
  };
}
